// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"fecfe153","184":"fecfe153","504":"fecfe153","778":"fecfe153"}[chunkId] + ".chunk.css";
};